import { GridModel } from "common/models/utility-models/list-utility.model";
import { CreditReportsModel } from "./credit-report-data-model";

export class CreditReportsGridModel extends CreditReportsModel { }

export class CreditReportsListingModel extends GridModel<CreditReportsModel> {
  filterData: any;
}